function setProcessList(state, ignoreProcesses) {
  if (ignoreProcesses && ignoreProcesses.length > 0) {
    const ignoredList = ignoreProcesses.split(',');
    ignoredList.forEach(item => {
      const indexOfItem = state.processesList.findIndex(x => x.Name === item.trim());
      if (indexOfItem > -1) state.processesList[indexOfItem].Val = true;
      else state.processesList.push({ Name: item.trim(), Val: true });
    });
  }
}

function setLicense(state, license) {
  if (license) {
    state.license = license;
  }
}

function removeProcess(state, processName) {
  if (!processName) return;
  const indexOfItem = state.processesList.findIndex(x => x.Name === processName.trim() && !x.keep);
  if (indexOfItem > -1) state.processesList.splice(indexOfItem, 1);
}

function isEmptyDataObject(obj) {
  return typeof obj !== 'object' || obj === null || obj === undefined || Object.keys(obj).length === 0;
}

export const Mutations = {
  setInputWithMenuSelectedOption(state, data) {
    state.inputsWithMenuSelectedOption = { ...state.inputsWithMenuSelectedOption, ...data };
  },
  mutateInputsData(state, data = {}) {
    state.inputsData = data;
  },
  setRegExpValidation(state, data) {
    state.regExpValidation = data;
  },
  initPortValidations(state, data = {}) {
    state.portsValidations = data;
  },
  mutatePortValidation(state, data) {
    const newValidations = { ...state.portsValidations };
    if (data.value === undefined) delete newValidations[data.field];
    else newValidations[data.field] = data.value;

    state.portsValidations = newValidations;
  },
  mutateDirtyState(state, data) {
    state.dirtyState = data;
  },
  setBackupCoordinatorStatus(state, data) {
    if (isEmptyDataObject(data)) {
      state.backupCoordinatorStatus.IsUnreachable = true;
      state.backupCoordinatorStatus.IsActive = false;
      state.backupCoordinatorStatus.IsBackup = state.settingsFromCoord?.BackupCoordinator;
    } else {
      state.backupCoordinatorStatus.IsBackup = data?.IsBackup;
      state.backupCoordinatorStatus.IsActive = data?.IsActive;
      state.backupCoordinatorStatus.IsUnreachable = false;
    }
  },
  setAllSettings(state, data) {
    if (!isEmptyDataObject(data)) {
      state.settingsFromCoord = data;
      state.settingsFromCoord.SslCnValidationPattern = data.SslCnValidationPattern.substring(1, data.SslCnValidationPattern.length - 1);
      setProcessList(state, data.IgnoreProcesses);
    }
  },
  setEnteredLicenseKeyValue(state, payload) {
    state.enteredLicenseKey = payload;
  },
  setSettingsValue(state, payload) {
    if (Array.isArray(payload)) {
      payload.forEach(item => {
        state.settingsFromCoord[item.field] = item.value;
      });
    } else state.settingsFromCoord[payload.field] = payload.value;
  },

  setSettingsLicenseValue(state, payload) {
    Object.keys(payload).forEach(itemKey => {
      state.license[itemKey] = payload[itemKey];
    });
  },

  setSettingsLicensePolling(state, payload) {
    if (payload) {
      const license = {};
      Object.keys(payload).forEach(k => {
        const v = payload[k];
        if (typeof v === 'string' && v.toLowerCase() === 'true') license[k] = true;
        else if (typeof v === 'string' && v.toLowerCase() === 'false') license[k] = false;
        else license[k] = v;
      });
      setLicense(state, license);
    }
  },
  ignoreProcessesUpdate(state, data) {
    state.processesList.forEach(x => {
      x.Val = false;
    }); // step 1 - false everything
    if (data.removeField) removeProcess(state, data.removeField);
    setProcessList(state, data.processesList); // step 3 - make from incoming data
  },
  removeProcessFromList(state, processName) {
    removeProcess(state, processName);
  },

  setCloudUrl(state, { cloudUrl }) {
    if (cloudUrl) {
      state.cloudUrl = cloudUrl;
    }
  },
  setCloudStatus(state, status) {
    state.cloudStatus = status;
    localStorage.setItem('cloudStatus', status);
  },
};
